<template>
  <Grid gtr="auto 1fr" class="predictions" gap="var(--r-space-md)">
    <Grid
      gaf="column"
      justify-content="space-between"
      align-items="center"
      class="header-tabs bg-white-1 shadow3 q-pt-sm q-pb-md q-pl-lg q-pr-xl"
    >
      <q-tabs align="left" class="text-heading-5 text-secondary-1" indicator-color="transparent">
        <Grid gaf="column" gap="var(--r-space-lg)">
          <q-route-tab
            v-for="tab of tabs"
            :key="tab.id"
            :to="tab.route"
            :ripple="false"
            style="padding: 0 var(--r-space-sm)"
            exact-active-class="text-heading-4"
          >
            {{ tab.name }}
          </q-route-tab>
        </Grid>
      </q-tabs>

      <Grid gaf="column">
        <RDropdown
          v-model="financialPeriodId"
          :options="financialPeriodOptions"
          :loading="loadingFinancialPeriods"
          style="width: 200px"
          emit-value
          map-options
          no-label
          no-hint
        ></RDropdown>

        <ButtonForDecisionMaking class="q-pl-md" />

        <RBtn v-if="false" type="text" size="small">
          <q-icon name="get_app" color="primary-1" size="18px"></q-icon>
          <span class="q-ml-xs">Export</span>
        </RBtn>
      </Grid>
    </Grid>

    <router-view></router-view>
  </Grid>
</template>

<script>
import PredictionsModule from './predictions-module'
// Libraries
import { mapActions, mapState, mapMutations } from 'vuex'
// Components
import ButtonForDecisionMaking from './subpages/renewal-proposal/components/ButtonForDecisionMaking'

export default {
  name: 'Predictions',

  components: {
    ButtonForDecisionMaking
  },

  data: () => ({
    tabs: [
      { id: 3, name: 'Scenarios', route: '/financial/predictions/scenarios' },
      { id: 1, name: 'Price Forecast', route: '/financial/predictions/price-forecast' },
      { id: 2, name: 'Recommendations', route: '/financial/predictions/recommendations' },
      { id: 4, name: 'Renewal Proposal', route: '/financial/predictions/renewal-proposal' }
    ]
  }),

  computed: {
    ...mapState('predictions', ['financialPeriods', 'loadingFinancialPeriods']),

    financialPeriodId: {
      get() {
        return this.$store.state.predictions.financialPeriodId
      },
      set(newValue) {
        this.setFinancialPeriodId(newValue)
      }
    },

    financialPeriodOptions() {
      return this.financialPeriods.map(period => ({
        label: `${this.formatDateForLocale(period.start_date)} - ${this.formatDateForLocale(period.end_date)}`,
        value: period.id
      }))
    }
  },

  created() {
    this.getAndSetFinancialPeriods()
    this.getAndSetDepartments()
  },

  beforeCreate() {
    this.$store.registerModule('predictions', PredictionsModule)
  },

  destroyed() {
    this.$store.unregisterModule('predictions')
  },

  methods: {
    ...mapMutations('predictions', ['setFinancialPeriodId']),
    ...mapActions('predictions', ['getAndSetFinancialPeriods', 'getAndSetDepartments'])
  }
}
</script>

<style lang="scss" scoped>
@import '~@/styles/mixins';

.predictions {
  .header-tabs {
    border-radius: 0 0 2px 2px;

    .q-tab {
      min-height: unset;
    }
  }
}
</style>
